import { Settings, ShieldCheck, BarChart3, PlayCircle } from "lucide-react";
import Seo, { buildBreadcrumbLd } from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import PageHero from "../components/PageHero";

const crumbs = [
  { label: "Startseite", to: "/" },
  { label: "Cookie-Einstellungen", to: "/cookie-einstellungen" },
];

const categories = [
  { icon: ShieldCheck, title: "Technisch erforderlich", text: "Notwendig für den Betrieb der Website. Immer aktiv und nicht abwählbar.", always: true },
  { icon: BarChart3, title: "Statistik", text: "Anonyme Auswertung der Nutzung, um die Website zu verbessern. Nur nach Einwilligung." },
  { icon: PlayCircle, title: "Externe Medien", text: "Inhalte von Drittanbietern (z. B. Kartendienste). Nur nach Einwilligung." },
];

export default function CookieEinstellungen() {
  return (
    <div data-testid="page-cookie-einstellungen">
      <Seo path="/cookie-einstellungen" title="Cookie-Einstellungen | Rümpeltaxi" description="Verwalten Sie Ihre Cookie-Einstellungen bei Rümpeltaxi." noindex jsonLd={buildBreadcrumbLd(crumbs)} />
      <Breadcrumbs items={crumbs} />
      <PageHero kicker="Rechtliches" title="Cookie-Einstellungen" lead="Sie entscheiden, welche optionalen Dienste geladen werden. Ihre Auswahl können Sie jederzeit ändern oder widerrufen." />
      <section className="bg-white py-16 md:py-24">
        <div className="container-page max-w-3xl">
          <div className="space-y-4">
            {categories.map((c) => (
              <div key={c.title} className="flex items-start gap-4 rounded-sm border border-light-gray bg-light-gray p-6">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-sm bg-white text-anthracite">
                  <c.icon className="h-5 w-5" />
                </span>
                <div>
                  <div className="flex items-center gap-2">
                    <h2 className="font-heading text-lg font-bold text-anthracite">{c.title}</h2>
                    {c.always && (
                      <span className="rounded-sm bg-anthracite px-2 py-0.5 text-xs font-semibold text-white">Immer aktiv</span>
                    )}
                  </div>
                  <p className="mt-1 text-sm text-mid-gray">{c.text}</p>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}
            className="mt-8 inline-flex items-center gap-2 rounded-sm bg-yellow px-6 py-3.5 font-heading font-bold text-brand-black transition-colors hover:bg-yellow-dark"
            data-testid="open-cookie-settings"
          >
            <Settings className="h-4 w-4" /> Einstellungen anpassen
          </button>
        </div>
      </section>
    </div>
  );
}
